import {FIELD_LIST_INTRO_RESULT_MIRACULOUS_RETINOL_SERIES} from "../../../utils/input-field-list-static-page";
import {useDispatch, useSelector} from "react-redux";
import InputField from "./input-field";
import {setMiraculousRetinolSeriesIntroDetail} from "../../../reducers/miraculous-retinol-series.reducer";
import React from "react";
import FormGeneralComponent from "../../../components/static-page/form-general.component";

const Intro = () => {
    const dispatch = useDispatch()
    const {introDetail} = useSelector(state => state.miraculousRetinolSeriesReducer)
    let fieldList = FIELD_LIST_INTRO_RESULT_MIRACULOUS_RETINOL_SERIES
    let showIntro = {
        label: 'Intro',
        key: 'show_intro',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const toggleList = [
        {
            title: 'Input Field',
            content: <InputField fieldList={fieldList} />
        }
    ]

    const onChange = (key, value) => {
        dispatch(setMiraculousRetinolSeriesIntroDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        console.log(introDetail)
        // submit form
    }

    return (
        <FormGeneralComponent
            data={introDetail}
            switchToggleField={showIntro}
            onChange={onChange}
            toggleList={toggleList}
            onSubmitHandler={onSubmitHandler}
            isLoading={false}
        />
    )
}

export default Intro